//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type ModelWriter } from "ckeditor5";
import {
  ACCORDION_SECTION_BODY,
  createAccordionSection,
  getAccordionElement,
  getAccordionSectionElement,
} from "./util";

export default class AddAccordionSectionCommand extends Command {
  execute(): void {
    this.editor.model.change((writer: ModelWriter) => {
      const selection = this.editor.model.document.selection;
      const accordion = getAccordionElement(selection);
      if (accordion) {
        const accordionSectionBody = getAccordionSectionElement(selection, ACCORDION_SECTION_BODY);
        let accordionSectionOffset: number | null = null;
        if (accordionSectionBody) {
          accordionSectionOffset = accordion.getChildStartOffset(accordionSectionBody);
        }
        if (accordionSectionOffset === null) {
          createAccordionSection(this.editor, writer, accordion);
        } else {
          createAccordionSection(this.editor, writer, accordion, accordionSectionOffset + 1);
        }
      }
    });
  }

  refresh() {
    const accordionSection = getAccordionSectionElement(this.editor.model.document.selection);
    this.isEnabled = !!accordionSection;
  }
}
